<input (click)="getGeolocation()" [readonly]="readonly" [value]="this.value" type="text">

